<div class="grid grid-cols-1">
  <mat-form-field subscriptSizing="dynamic">
    <mat-label>{{ label }}</mat-label>
    <input
      #input
      matInput
      ngDefaultControl
      type="text"
      [formControl]="control"
      [placeholder]="placeholder"
      [matAutocomplete]="autocomplete"
      (input)="filterOptions()"
      (focus)="filterOptions()"
      />
      @if (!input?.value) {
        <button mat-icon-button matSuffix class="mr-2">
          <mat-icon>search</mat-icon>
        </button>
      }
      @if (input?.value) {
        <button mat-icon-button matSuffix class="mr-2" (click)="clearSelect()">
          <mat-icon>close</mat-icon>
        </button>
      }
      <mat-autocomplete requireSelection #autocomplete="matAutocomplete" [displayWith]="display">
        @for (option of filteredOptions; track option) {
          <mat-option [value]="option">
            {{ display(option) }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
